import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LayoutExternalComponent } from '@loup-transload-ui-app/common-components';
import { DynamicTitleService } from '@loup-transload-ui-app/common-services';

@Component({
  selector: 'app-root',
  imports: [LayoutExternalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(private dynamicTitleService: DynamicTitleService) {
    this.dynamicTitleService.init();
  }
}
